import { render, staticRenderFns } from "./SimpleHorizontalIndicator.vue?vue&type=template&id=4c2ee7a4&scoped=true"
import script from "./SimpleHorizontalIndicator.vue?vue&type=script&lang=js"
export * from "./SimpleHorizontalIndicator.vue?vue&type=script&lang=js"
import style0 from "./SimpleHorizontalIndicator.vue?vue&type=style&index=0&id=4c2ee7a4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2ee7a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c2ee7a4')) {
      api.createRecord('4c2ee7a4', component.options)
    } else {
      api.reload('4c2ee7a4', component.options)
    }
    module.hot.accept("./SimpleHorizontalIndicator.vue?vue&type=template&id=4c2ee7a4&scoped=true", function () {
      api.rerender('4c2ee7a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-wizard/indicators/SimpleHorizontalIndicator.vue"
export default component.exports